/**
 * RMFF Text Link Blocks Widget TypeScript
 */
function initTextLinkBlocks() {
    // Equalize heights on mobile for text link blocks
    equalizeMobileHeights();
}
function equalizeMobileHeights() {
    var widgets = document.querySelectorAll('.rmff-text-link-blocks-widget');
    widgets.forEach(function (widget) {
        var blocks = widget.querySelectorAll('.rmff-text-link-block');
        if (blocks.length === 0)
            return;
        // Function to reset heights and set equal heights
        var setEqualHeights = function () {
            // Reset heights first
            blocks.forEach(function (block) {
                block.style.height = 'auto';
            });
            // Only apply equal heights on mobile (1024px and below)
            if (window.innerWidth <= 1024) {
                var maxHeight_1 = 0;
                // Find the tallest block
                blocks.forEach(function (block) {
                    var height = block.offsetHeight;
                    if (height > maxHeight_1) {
                        maxHeight_1 = height;
                    }
                });
                // Set all blocks to the same height
                blocks.forEach(function (block) {
                    block.style.height = maxHeight_1 + 'px';
                });
            }
        };
        // Set equal heights on load
        setEqualHeights();
        // Set equal heights on resize
        window.addEventListener('resize', setEqualHeights);
        // Set equal heights when images load (if any)
        var images = widget.querySelectorAll('img');
        images.forEach(function (img) {
            img.addEventListener('load', setEqualHeights);
        });
    });
}
// Export for use in index.ts
export { initTextLinkBlocks };
